module.exports = __webpack_public_path__ + "assets/img/supplier_level1.52f69105.svg";